import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import UnassignedObis from '../../UnassignedObis';
import { getPermissionForComponent } from '../../../utils/permissionsUtils';

function UnAssignedObiModal({
  showUnassignedObi,
  unassignedLoading,
  onAssignObi,
  closeUnassignedObis,
  populateEpis,
  user,
  onAddEpi,
}) {
  const modifyEPIS = getPermissionForComponent('modifyEPIS',user.permissionsGroup);
  const deleteEpiPermission = getPermissionForComponent('deleteEpi',user.permissionsGroup);
  return (
    <Modal isOpen={showUnassignedObi}>
      <ModalHeader>
        Select Unassigned EPI
        {(modifyEPIS === 'write' || modifyEPIS === 'both' || deleteEpiPermission === 'write' || deleteEpiPermission === 'both') && (
          <Button
            color="primary"
            style={{ position: 'absolute', right: '150px' }}
            size="sm"
            onClick={() => {
              onAddEpi();
            }}
          >
            {unassignedLoading && (
              <FontAwesomeIcon fixedWidth spin className="port-info-icon" icon="spinner" />
            )}
            <span>{unassignedLoading ? ' Adding EPI...' : 'Add EPI'}</span>
          </Button>
        )}
        <Button
          color="primary"
          style={{ position: 'absolute', right: '10px' }}
          size="sm"
          disabled={unassignedLoading}
          onClick={() => {
            populateEpis();
          }}
        >
          {unassignedLoading && (
            <FontAwesomeIcon fixedWidth spin className="port-info-icon" icon="spinner" />
          )}
          <span>{unassignedLoading ? ' Reloading EPIs...' : 'Reload EPIs'}</span>
        </Button>
      </ModalHeader>
      <ModalBody>
        <UnassignedObis onAssignObi={onAssignObi} />
      </ModalBody>
      <ModalFooter>
        <Button outline color="secondary" onClick={closeUnassignedObis}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default UnAssignedObiModal;
